// src/firebase/ensureAnonUser.js
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";

let _inFlight = null;

export const ensureAnonUser = async ({ waitMs = 400 } = {}) => {
  const auth = getAuth();

  // Fast path: already signed in (anon or real)
  if (auth.currentUser) return auth.currentUser;

  // Deduplicate concurrent calls
  if (_inFlight) return _inFlight;

  _inFlight = (async () => {
    // Give Firebase a moment to restore a persisted user
    const restored = await new Promise((resolve) => {
      let done = false;

      const unsub = onAuthStateChanged(auth, (u) => {
        if (done) return;
        done = true;
        unsub();
        resolve(u || null);
      });

      setTimeout(() => {
        if (done) return;
        done = true;
        try { unsub(); } catch {}
        resolve(null);
      }, waitMs);
    });

    if (restored) return restored;

    // Otherwise sign in anonymously (network)
    const { user } = await signInAnonymously(auth);
    return user;
  })();

  try {
    return await _inFlight;
  } finally {
    _inFlight = null;
  }
};
